import { REPORT_TYPE_IDS } from '../../consts/reportTypes';

export const REPORT_TYPE_LABELS = {
  [REPORT_TYPE_IDS.AIF002]: 'AIF002 (Fund Transparency Report)',
  [REPORT_TYPE_IDS.AIF001]: 'AIF001 (AIFMD Manager Report)'
};
